import * as Yup from 'yup'

import validations, { customMethods } from '@/translations/validations'

export const emptyStringToNull = (value, origin) => {
  if (typeof origin === 'string' && origin === '') return null
  return value
}

function trimmed() {
  return this.transform(v => (typeof v === 'string' ? v.trim() : v)).trim()
}

function hasLetterChars(message = customMethods.hasLetterChars) {
  return this.test('hasLetterChars', message, value => /[A-Z]|[a-z]/.test(value))
}

function hasSpecialChars(message = customMethods.hasSpecialChars) {
  return this.test('hasSpecialChars', message, value => /.*\W|_.*/.test(value))
}

function hasDigits(message = customMethods.hasDigits) {
  return this.test('hasDigits', message, value => /.*[0-9].*/.test(value))
}

function disallowSpaces(message = customMethods.disallowSpaces) {
  return this.test('disallowSpaces', message, value => !/\s+/g.test(value))
}

function hasKeys(message = customMethods.hasKeys) {
  return this.test('hasKeys', message, value => !!Object.entries(value).length)
}

// https://github.com/jquense/yup/issues/97#issuecomment-306547261
function equalTo(ref, refLabel, message = customMethods.equalTo) {
  const updatedMessage = `${message} ${refLabel || ''}`
  return this.test('equalTo', updatedMessage, function (value) {
    return value === this.resolve(ref)
  })
}

function notEqualTo(ref, refLabel, message = customMethods.notEqualTo) {
  const updatedMessage = `${message} ${refLabel || ''}`
  return this.test('notEqualTo', updatedMessage, function (value) {
    return value !== this.resolve(ref)
  })
}

function phoneNumber(options) {
  const {
    path = 'phoneNumber',
    minDigits = 7,
    maxDigits = 14,
    maxLength = 20,
  } = options

  return this.test('phoneNumber', function (value) {
    if (!value) return true

    const hasLetters = /[A-Za-z]/.test(value)

    if (hasLetters) {
      return this.createError({ message: 'cannot contain letters', path })
    }

    const digitsOnly = value.replace(/\D/g, '')

    if (digitsOnly.length < minDigits) {
      return this.createError({ message: `must contain at least ${minDigits} digits`, path })
    }

    if (digitsOnly.length > maxDigits) {
      return this.createError({ message: `must contain at most ${maxDigits} digits`, path })
    }

    if (value.length > maxLength) {
      return this.createError({ message: `must contain at most ${maxLength} characters`, path })
    }

    return true
  })
}

Yup.setLocale(validations)

Yup.addMethod(Yup.string, 'trimmed', trimmed)
Yup.addMethod(Yup.string, 'equalTo', equalTo)
Yup.addMethod(Yup.string, 'notEqualTo', notEqualTo)
Yup.addMethod(Yup.number, 'notEqualTo', notEqualTo)
Yup.addMethod(Yup.string, 'hasDigits', hasDigits)
Yup.addMethod(Yup.string, 'hasSpecialChars', hasSpecialChars)
Yup.addMethod(Yup.string, 'hasLetterChars', hasLetterChars)
Yup.addMethod(Yup.string, 'disallowSpaces', disallowSpaces)
Yup.addMethod(Yup.object, 'hasKeys', hasKeys)
Yup.addMethod(Yup.string, 'phoneNumber', phoneNumber)

export default Yup
